<app-timeline-transport-order-information [order]='this.currentOrder' (closed)='this.onOrderInfoDrawerClosed()'></app-timeline-transport-order-information>
<!-- <app-timeline-transport-all-orders></app-timeline-transport-all-orders> -->
  <app-timeline-add-site [isLoaded]="loadNewSiteModal"></app-timeline-add-site>
<div class='acceptedOrdersContainer'>
  <div class='header'>
    <span class='headerLabel'><i class="fas fa-fw fa-truck-loading"></i> {{ this.getAcceptedOrdersLabel() }}</span>
    <button class='btn btn-secondary btn-small' (click)='this.loadOrders()'><i class="fas fa-sync-alt"></i></button>
  </div>

  <div class="bodyContainer">

    <div class='acceptedOrdersFilters'>
      <ng-select class='acceptedOrdersSelect' placeholder='Customer' [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
        @for (item of this.accounts; track item) {
          <ng-option [selected]='this.searchFilters.customer === item.id' [value]='item.id'>{{ item.name }}</ng-option>
        }
      </ng-select>

      <ng-select class='acceptedOrdersSelect' placeholder='Site' [(ngModel)]="this.searchFilters.site" (change)='this.searchFilters.site = $event;'>
        @for (item of this.sites; track item) {
          <ng-option [value]='item.id' [selected]='this.searchFilters.site === item.id'>{{ item.name }}</ng-option>
        }
      </ng-select>

      <ng-select class='acceptedOrdersSelect' placeholder='Tip Site' [(ngModel)]="this.searchFilters.tipSite" (change)='this.searchFilters.tipSite = $event;'>
        @for (item of this.tips; track item) {
          <ng-option [selected]='this.searchFilters.tipSite === item.id' [value]='item.id'>{{ item.name }}</ng-option>
        }
      </ng-select>

      <input type='text' class='form-control acceptedOrdersInput' placeholder="Job Parent Id" [(ngModel)]='this.searchFilters.orderId'/>

      <div class='acceptedOrdersActionRow'>
        <button class='btn btn-primary btn-sm' (click)='this.loadOrdersForSearch()'>Search</button>
        <button class='btn btn-danger btn-sm' (click)='this.clear()'>Clear</button>
        <!-- <button class='btn btn-secondary btn-sm' (click)='this.openModal("transportAllOrdersModal")'>Show Orders</button> -->
      </div>
    </div>

    <div class='acceptedOrdersDivider'></div>

    <div class='acceptedOrdersActionRow'>
      <button class='btn btn-secondary btn-sm' routerLink='/orders/new/accounts'>+ New Order</button>
      <button class='btn btn-secondary btn-sm' (click)='this.loadNewSiteModal = true; this.newSite()'>+ New Account/Site</button>
    </div>

    <!-- <div class="form-group">
    <label for="inputPassword4">Sort by</label>
    <select class='form-control' (change)='this.sortBy = $event.target.value; this.loadOrders()'>
      <option value='time'>Time</option>
      <option value='account'>Account</option>
      <option value='po-number'>PO Number</option>
    </select>
  </div> -->

  <!-- used for clone icon don't remove-->
  <div id="div2" style='display:none;z-index:9999999999'>Test</div>

  <div class='acceptedOrdersList'>
  @if (this.orders.length > 0) {
    @for (order of this.orders; track order) {
      <!-- Normal orders -->
      @if (order.shredderOrderTypeId !== 3) {
        <div
          class='orderContainer'
          [class.changed]='order.createdBy !== order.updatedBy && order.updatedBy !== -1 && !isTippingOnOwnAccount(order)'
          [class.own]="isTippingOnOwnAccount(order)"
          [class.expired]="order.orderStatusId === 4"
          [class.dragging]='this.draggingId == order.id'
          [class.orderInfoActive]='this.activeOrderInfoId === order.id'
          data-id='{{ order.id }}'
          draggable="true"
          [attr.title]='this.getHoverText(order)'
          (click)='this.openOrderInfo(order)'
          (dragstart)='dragStart($event, order)'
          (dragend)='dragEnd($event)'>
          <span
            class="orderQtyBanner"
            [class.badge-secondary]='this.getAllocatedQty(order) === 0'
            [class.badge-primary]='this.getAllocatedQty(order) < this.getOrderQty(order)'
            [class.badge-success]='this.getAllocatedQty(order) === this.getOrderQty(order)'
            [class.badge-danger]='this.getAllocatedQty(order) > this.getOrderQty(order)'
          >{{this.getAllocatedQty(order)}}/{{this.getOrderQty(order)}}</span>
          <div class="orderDetails">
            <strong>{{ order.account.name }}</strong>
            {{ order.site.name }}
            @if (order.tipSite !== null) {
              TO {{ order.tipSite.name }}
            }
            <br />
            <span class='orderDetailLabel'>Job Type</span> <strong>Per {{ this.getUnitForJob(order) }}</strong>
            <br />
            <span class='orderDetailLabel'>Parent Job Id</span> <strong>{{ order.id }}</strong>
            <br />
            @if (order.createdBy !== order.updatedBy && order.updatedBy !== -1) {
              <span><span class='orderDetailLabel'>Changed By</span> {{ order.updatedUser.firstName }} {{ order.updatedUser.lastName }}</span><br />
            }
            @if (this.orderTypeId === 8 && order.shredderOrderTypeId === 3) {
              @if (!order.isPrepaid) {
                <span>Delivery</span>
              }
              @if (order.isPrepaid) {
                <span>Collection</span>
              }
            }
          </div>
        </div>
      }
      <!-- Prepaid, over allocated Delivery -->
      @if (order.shredderOrderTypeId === 3 && !order.isPrepaid && order.allocated >= order.qty) {
        <div
          class='orderContainer'
          [class.orderInfoActive]='this.activeOrderInfoId === order.id'
          (click)='this.openOrderInfo(order)'
          >
          <span
            class="orderQtyBanner"
            [class.badge-secondary]='order.allocated === 0'
            [class.badge-primary]='order.allocated < order.qty'
            [class.badge-success]='order.allocated === order.qty'
            [class.badge-danger]='order.allocated > order.qty'
          >{{order.allocated}}/{{order.qty}}</span>
          <div class="orderDetails">
            <strong>{{ order.account.name }}</strong>
            {{ order.site.name }}
            <br />
            @if (this.orderTypeId === 8 && order.shredderOrderTypeId === 3) {
              @if (!order.isPrepaid) {
                <span>Delivery</span>
              }
              @if (order.isPrepaid) {
                <span>Collection</span>
              }
            }
          </div>
        </div>
      }
      <!-- Prepaid, underallocated Delivery -->
      @if (order.shredderOrderTypeId === 3 && !order.isPrepaid && order.allocated < order.qty) {
        <div
          class='orderContainer'
          [class.dragging]='this.draggingId == order.id'
          [class.orderInfoActive]='this.activeOrderInfoId === order.id'
          data-id='{{ order.id }}'
          draggable="true"
          (click)='this.openOrderInfo(order)'
          (dragstart)='dragStart($event, order)'
          (dragend)='dragEnd($event)'>
          <span
            class="orderQtyBanner"
            [class.badge-secondary]='order.allocated === 0'
            [class.badge-primary]='order.allocated < order.qty'
            [class.badge-success]='order.allocated === order.qty'
            [class.badge-danger]='order.allocated > order.qty'
          >{{order.allocated}}/{{order.qty}}</span>
          <div class="orderDetails">
            <strong>{{ order.account.name }}</strong>
            {{ order.site.name }}
            <br />
            @if (this.orderTypeId === 8 && order.shredderOrderTypeId === 3) {
              @if (!order.isPrepaid) {
                <span>Delivery</span>
              }
              @if (order.isPrepaid) {
                <span>Collection</span>
              }
            }
          </div>
        </div>
      }
      <!-- Prepaid collection -->
      @if (order.shredderOrderTypeId === 3 && order.isPrepaid) {
        <div
          class='orderContainer'
          [class.dragging]='this.draggingId == order.id'
          [class.orderInfoActive]='this.activeOrderInfoId === order.id'
          data-id='{{ order.id }}'
          draggable="true"
          (click)='this.openOrderInfo(order)'
          (dragstart)='dragStart($event, order)'
          (dragend)='dragEnd($event)'>
          <span
            class="orderQtyBanner"
            [class.badge-secondary]='order.allocated === 0'
            [class.badge-primary]='order.allocated < order.qty'
            [class.badge-success]='order.allocated === order.qty'
            [class.badge-danger]='order.allocated > order.qty'
          >{{order.allocated}}/{{order.qty}}</span>
          <div class="orderDetails">
            <strong>{{ order.account.name }}</strong>
            {{ order.site.name }}
            <br />
            @if (this.orderTypeId === 8 && order.shredderOrderTypeId === 3) {
              @if (!order.isPrepaid) {
                <span>Delivery</span>
              }
              @if (order.isPrepaid) {
                <span>Collection</span>
              }
            }
          </div>
        </div>
      }
    }
    <div class="gridPagination">
      <ul>
        @if (this.isPrevActive()) {
          <li>
            <button
              class="btn btn-secondary"
              type="button"
              name="button"
              (click)="onPaginationPageClicked(this.getCurrentPage() - 1)"
              >
              &lt;
            </button>
          </li>
        }
        @if (this.paginationService.getTotalPages() <= 30) {
          @for (page of this.getPagesArray(); track page) {
            <li>
              <button
                class="btn btn-secondary"
                type="button"
                name="button"
                (click)="onPaginationPageClicked(page)"
                [class.active]="page === this.getCurrentPage()"
                >
                {{ page }}
              </button>
            </li>
          }
        }
        @if (this.paginationService.getTotalPages() > 30) {
          @for (page of this.paginationService.getShortPagesRange(this.paginationService.getPage(), this.paginationService.getTotalPages()); track page) {
            @if (page !== "...") {
              <li>
                <button
                  class="btn btn-secondary"
                  type="button"
                  name="button"
                  (click)="onPaginationPageClicked(page)"
                  [class.active]="page === this.getCurrentPage()"
                  >
                  {{ page }}
                </button>
              </li>
            }
            @if (page === "...") {
              <span>...</span>
            }
          }
        }
        @if (this.isNextActive()) {
          <li>
            <button
              class="btn btn-secondary"
              type="button"
              name="button"
              (click)="onPaginationPageClicked(this.getCurrentPage() + 1)"
              >
              &gt;
            </button>
          </li>
        }
      </ul>
    </div>
  }
  @if (this.orders.length === 0) {
    <div style='color:red;font-weight:bold'>No results found</div>
  }
  </div>
</div>
</div>
